// extracted by mini-css-extract-plugin
export default {"reviewVideoMenu":"qc-submitted-videos-inquiring_reviewVideoMenu__tWmfY","reviewVideoTabMain":"qc-submitted-videos-inquiring_reviewVideoTabMain__t+JZU"};